import { Component, OnInit } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { Constants } from '../constants/constants';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { ToastService } from '../service/toast.service';
import { UtilService } from '../service/util.service';

@Component({
  selector: 'app-certificates',
  templateUrl: './certificates.component.html',
  styleUrls: ['./certificates.component.scss']
})
export class CertificatesComponent implements OnInit {

  accountDetail: any;

  certificates: Array<any>;
  certificatesMasterData: Array<any>;

  statusFilterOption: Set<string> = new Set();

  selectedProvisionedCertificate: any
  selectedFilterOption: string = 'all';

  isViewCertificateDetail = false;

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toastService: ToastService) { }

  ngOnInit() {
    this.accountDetail = this.apiService.accountDetail;
    this.getCertificates();
  }

  getCertificates() {
    this.utilService.showSpinner();
    this.apiService.getCertificates().then((data) => {
      this.utilService.hideSpinner();
      console.log("certificate list : ", data);
      this.certificates = data;
      // this.filterUniqueCertificates();
      this.certificatesMasterData = this.certificates.map(x => Object.assign({}, x));
      // this.initFilterOption();
      this.onFilter(this.selectedFilterOption);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getCertificates();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  initFilterOption() {
    this.statusFilterOption = new Set();
    if (isNullOrUndefined(this.certificates) || this.certificates.length < 1) return;
    this.certificates.forEach(certificate => {
      this.statusFilterOption.add(certificate.status);
    });
  }

  onFilter(option: string) {
    if (isNullOrUndefined(option)) return;
    option = option.toLowerCase();
    this.selectedFilterOption = option;
    var isSelectedFilterOptionNotExists = this.isFilterOptionNotExists(this.selectedFilterOption);
    var certificates = new Array();
    if (option == "status" || option == "all" || isSelectedFilterOptionNotExists) {
      certificates = this.certificatesMasterData;
      if(option != "all" && isSelectedFilterOptionNotExists) {
        this.resetCertificateStatusDropdown();
      }
    } else {
      this.certificatesMasterData.forEach(certificate => {
        if (certificate.status.toLowerCase() == option)
          certificates.push(certificate);
      });
    }
    this.certificates = certificates;
  }

  isFilterOptionNotExists(selectedFilterOption: string): boolean {
    var statusFilterOption = Array.from(this.statusFilterOption.values());
    return !statusFilterOption.some(filterOption => filterOption.toLowerCase() === selectedFilterOption);
  }

  resetCertificateStatusDropdown() {
    var item = document.getElementById('certificateStatusSelect');
    item["selectedIndex"] = 0;
  }

  onCertificateSelected(certificate) {
    // this.selectedProvisionedCertificate = certificate;
    // this.isViewCertificateDetail = true;
  }

  onCloseCertificateDetail() {
    this.isViewCertificateDetail = false;
    this.selectedProvisionedCertificate = null;
  }

  filterUniqueCertificates() {
    var uniqueCertificates = [];
    this.certificates.forEach(certificate => {
      if(!uniqueCertificates.some(cert => cert.oemCustomerId === certificate.oemCustomerId)) {
        uniqueCertificates.push(certificate);
      }
    });
    this.certificates = uniqueCertificates;
  }

}
